import { Availability } from './Availability';
import { Metadata } from './Metadata';
import { Option } from './Option';

export class OptionGroup {
    id: number;
    chainmodifierid: number;
    description: string;
    mandatory: boolean;
    options: Array<Option>;
    parentchoiceid: null;
    minselects: string | null;
    maxselects: string | null;
    minaggregatequantity: string | null;
    maxaggregatequantity: string | null;
    minchoicequantity: string;
    maxchoicequantity: string;
    supportschoicequantities: boolean;
    choicequantityincrement: string;
    availability: Availability;
    metadata: Array<Metadata> | null;
    explanationtext: string;
    hidechoicecost: boolean;

    constructor(init?: Partial<OptionGroup>) {
        Object.assign(this, init);
    }

    public static Make(obj: any): OptionGroup {
        const optionGroup = new OptionGroup();
        Object.assign(optionGroup, obj);
        return optionGroup;
    }

    public get IsMultiSelect(): boolean {
        return OptionGroup.IsMultiSelect(this);
    }

    public static IsMultiSelect(optionGroup: OptionGroup): boolean {
        if (optionGroup.maxselects === '1') return false;
        if (optionGroup.maxselects !== '1' && optionGroup.mandatory) return false;
        return true;
    }

    public static IsMasterOptionGroup(optionGroup: OptionGroup): boolean {
        return !!optionGroup.options.find((o) => o.modifiers !== null && o.modifiers.length > 0);
    }
}
